import moment from 'moment'

/**
 * Función de orden de las capas
 * @param {*} period 
 */
export default function(period) {
  return (a, b) => {
    const layerNameA = a.name
    const layerNameB = b.name

    const months = moment.localeData('es').months().map(m => m.toLowerCase())
    const trims = ['primavera', 'verano', 'otoño', 'invierno']

    const regexMonth = new RegExp(`(${months.join('|')})`)
    const regexTrim = new RegExp(`(${trims.join('|')})`)
    const regexYear = /\d{4}/


    const trimsDates = {
      // trimestre: [mes, dia]
      "primavera": [2, 21],
      "verano": [5, 21],
      "otoño": [8, 23],
      "invierno": [11, 21]
    }

    const [yearA] = (layerNameA.match(regexYear) || []).map(Number)
    const [yearB] = (layerNameB.match(regexYear) || []).map(Number)


    const [monthA] = layerNameA.match(regexMonth) || []
    const [monthB] = layerNameB.match(regexMonth) || []

    const [trimNameA] = layerNameA.match(regexTrim) || []
    const [monthTrimA, dayTrimA] = (trimsDates[trimNameA] || [])

    const [trimNameB] = layerNameB.match(regexTrim) || []
    const [monthTrimB, dayTrimB] = (trimsDates[trimNameB] || [])

    let dateA, dateB

    switch(period) {
      case 'Anual': 
        dateA = Date.UTC(yearA, 0, 1)
        dateB = Date.UTC(yearB, 0, 1)
        return dateB - dateA
      case 'Mensual':
        dateA = Date.UTC(yearA, months.findIndex(m => m == monthA), 1)
        dateB = Date.UTC(yearB, months.findIndex(m => m == monthB), 1)
        return dateB - dateA
      case 'Trimestral':
        dateA = Date.UTC(yearA, monthTrimA, dayTrimA)
        dateB = Date.UTC(yearB, monthTrimB, dayTrimB)
        const trimIndexA = trims.findIndex(t => t === trimNameA)
        const trimIndexB = trims.findIndex(t => t === trimNameB)
        
        if(yearA === yearB) {
          return trimIndexB - trimIndexA;
        }

        return dateB - dateA;
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/core/utils/sort.js